$(function () {
    $('.basketImport__btn').on('click', function () {
        $('.basketImport').slideToggle();
    })
});